// extracted by mini-css-extract-plugin
export default {"telaCentralStepForm":"stepForm_telaCentralStepForm__beEOX","conteudo":"stepForm_conteudo__j2NCx"};